<template>
  <canvas
    ref="chartCanvas"
    class="chart_canvas"
  />
</template>

<script setup>
import { LineController, LineElement, PointElement, CategoryScale, LinearScale, BarController, BarElement, Chart } from 'chart.js'

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, BarController, BarElement)

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  config: {
    type: Object,
    required: true
  },
  displayScale: {
    type: String,
    default: ''
  }
})

watch(() => props.data, () => {
  if (!chart) {
    return
  }

  enableChartAnimation()

  chart.data.datasets[0].data = props.data.maxt_list
  chart.data.datasets[1].data = props.data.mint_list
  chart.data.datasets[2].data = props.data.prec_list
  chart.update()
})

const enableChartAnimation = () => {
  if (!chart) {
    return
  }

  chart.options.animation = {
    duration: 250,
    easing: 'easeOutQuad'
  }
}

const chartCanvas = ref(null)
let chart = null

const setup = () => {
  if (!chartCanvas.value) {
    return
  }

  const labels = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']

  const data = {
    labels: labels,
    datasets: [
      {
        label: '最高気温',
        data: props.data.maxt_list,
        borderColor: '#F64D00',
        fill: false,
        yAxisID: 'y'
      },
      {
        label: '最低気温',
        data: props.data.mint_list,
        borderColor: '#0075F3',
        fill: false,
        yAxisID: 'y'
      },
      {
        label: '降水量',
        data: props.data.prec_list,
        backgroundColor: '#D4EAFF',
        type: 'bar',
        yAxisID: 'y1'
      }
    ]
  }

  const options = {
    scales: {
      x: {
        border: {
          display: false
        },
        offset: true,
        grid: {
          display: false
        },
        ticks: {
          font: {
            size: 9.5
          }
        }
      },
      y: {
        position: 'left',
        border: {
          display: false
        },
        ticks: {
          display: props.displayScale === 'temp',
          callback: (value) => {
            return value + '℃'
          },
          stepSize: 5
        },
        min: props.config.tmpGraphMin,
        max: props.config.tmpGraphMax
      },
      y1: {
        position: 'right',
        border: {
          display: false
        },
        grid: {
          display: false
        },
        ticks: {
          display: props.displayScale === 'prec',
          callback: (value) => {
            return value + 'mm'
          },
          stepSize: 100
        },
        min: props.config.precGraphMin,
        max: props.config.precGraphMax
      }
    },
    animation: false,
    elements: {
      point: {
        pointStyle: 'circle',
        backgroundColor: function (context) {
          return context.dataset.borderColor
        },
        hoverRadius: 3
      },
      bar: {
        hoverBackgroundColor: '#D4EAFF'
      }
    },
    responsive: true,
    aspectRatio: 1.1
  }

  chart = new Chart(chartCanvas.value, {
    type: 'line',
    data: data,
    options: options
  })
}

onMounted(() => {
  setup()
})
</script>

<style scoped>
.chart_canvas {
  width: 290px;
}
</style>
